export default "__VITE_ASSET__aB$A6GUz__"